<template>
    <div class="container">
      <div class="succ">
        <img src="../../assets/images/act_success.png" alt=""/>
        <span>核销成功</span>
      </div>
      <!-- <p class="desc">已成功报名活动，欢迎您的到来</p> -->
      <div class="button">
           <mt-button class="btn_primary" v-on:click="toIndex">返回</mt-button>
           <!-- <mt-button class="btn_default" v-on:click="toOrderList">查看订单</mt-button> -->
      </div>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'activitySuccess',
    data () {
      return {
  
      }
    },
    methods: {
      toIndex () {
        // this.$router.push('/activity')
       this.$router.go(-1)
      },
      toOrderList () {
        this.$router.push('/myOrder')
      }
    }
  }
  </script>
  <style lang='less' scoped>
  @import "../../assets/css/common.less";
  body {
    min-height: 100vh;
    background: #fff;
  }
  .container {
      background: #fff;
  }
  .succ{
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 120px;
    margin-bottom: 28px;
    // height:66px;
    img{
      display: block;
      width:44px;
      height:44px;
      margin-bottom:14px;
    }
    span{
      height:66px;
      font-size:48px;
      font-weight:bold;
      color:rgba(51,51,51,1);
      line-height:66px;
    }
  }
 
  
  .desc{
    width:100%;
    height:40px;
    .fontSize(14px);
    color:@color9;
    line-height:40px;
    margin:0 auto 112px;
    text-align: center;
  }
  
  .button{
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
      .btn_primary{
    //   margin-left: 32px;
      width:332px;
      height:68px;
      background:#fff;
      .border(#96AAF0);
      border-radius:4px;
      .fontSize(14px);
      color:@color17;
      line-height:68px;
      display: block;
      background:rgba(243,245,253,1);
      }
  
      .btn_default{
        // margin-right: 32px;
        width:332px;
        height:68px;
        background:@color17;
        .border(@color17);
        border-radius:4px;
        .fontSize(14px);
        color:#fff;
        line-height:68px;
        display: block;
      }
  }
  
  
  </style>